// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"b0c70c4b","990":"2b3e371f"}[chunkId] + ".chunk.js";
};